import { RxDashboard } from "react-icons/rx";
import { MdOutlineDocumentScanner, MdOutlineLiveHelp } from "react-icons/md";
import { TbUsers, TbReportSearch, TbUser } from "react-icons/tb";
import { GrDocumentImage } from "react-icons/gr";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { RiUserSettingsLine } from "react-icons/ri";
import ProClimeLogo from "../../images/ProClimeLogo.png";
import ProClimeLogoSecondary from "../../images/ProClimeLogoSecondary.png";
import { NavLink } from "react-router-dom";
import { ReactElement } from "react";
import { UserRoles } from "../../types";
import { useUserLastLoginSelector, useUserRoleSelector } from "../../store/users/selectors";

interface SideBarProps {
  isSideBarOpen: boolean;
}

type SideBarMenuItem = {
  icon: ReactElement;
  title: string;
  route?: string;
  roles?: UserRoles[];
};

const SideBar = ({ isSideBarOpen }: SideBarProps) => {
  const lastLogin = useUserLastLoginSelector();
  const userRole: UserRoles = useUserRoleSelector() ?? UserRoles.GENERAL;
  const sideBarMenuItems: SideBarMenuItem[] = [
    {
      icon: <RxDashboard />,
      title: "Dashboard",
      route: "dashboard",
      // roles: [],
    },
    {
      icon: <MdOutlineDocumentScanner />,
      title: "Projects",
      route: "",
      roles: [UserRoles.GENERAL, UserRoles.ADMIN, UserRoles.ADMIN_APPROVER],
    },
    {
      icon: <TbUsers />,
      title: "Customers",
    },
    {
      icon: <GrDocumentImage />,
      title: "Project Design Documents",
      route: "Project-Design-Document",
      roles: [UserRoles.ADMIN, UserRoles.ADMIN_APPROVER],
    },
    {
      icon: <HiOutlineClipboardDocumentList />,
      title: "Reports",
    },
    {
      icon: <RiUserSettingsLine />,
      title: "User Management",
    },
    {
      icon: <TbReportSearch />,
      title: "Audit Trial",
      route: "audit-trail",
      roles: [UserRoles.ADMIN, UserRoles.ADMIN_APPROVER],
    },
    {
      icon: <TbUser />,
      title: "Users",
      route: "users",
      roles: [UserRoles.ADMIN_APPROVER],
    },
    {
      icon: <MdOutlineLiveHelp />,
      title: "Help & Support",
      route: "help-support",
      roles: [UserRoles.GENERAL, UserRoles.ADMIN, UserRoles.ADMIN_APPROVER],
    },
  ];
  const filteredSideBarMenuItems = sideBarMenuItems.filter(
    (item) => item.roles?.includes(userRole) ?? false,
  );

  return (
    <div
      className={`sticky top-0 h-screen ${
        isSideBarOpen ? "w-72" : "w-20"
      } border-r border-r-gray-100 transition-all duration-100 ease-in-out`}
      id="sidebar"
    >
      {/* logo goes here */}
      <div className="h-11 py-4 text-center">
        {isSideBarOpen ? (
          <img
            src={ProClimeLogo}
            alt="proclime logo"
            className={`mx-auto block h-11 ${isSideBarOpen ? "block" : "hidden scale-0"}`}
          />
        ) : (
          <img
            src={ProClimeLogoSecondary}
            alt="proclime secondary logo"
            className={`mx-auto h-11  ${!isSideBarOpen ? "block" : "hidden"}`}
          />
        )}
      </div>

      {/* links */}
      <nav className="mx-auto mt-8 w-full px-2">
        {filteredSideBarMenuItems.map((menuItem, index) => {
          return (
            <NavLink
              key={index}
              className={({ isActive }) =>
                `flex h-[44px] w-full cursor-pointer items-center ${
                  isSideBarOpen ? "gap-4" : "gap-0"
                } hover:bg-[rgba(72,47,139,0.05)] hover:text-purple-900 ${
                  !isSideBarOpen && "rounded-l-lg"
                } ${
                  isActive && "bg-[rgba(72,47,139,0.05)] font-medium text-purple-900"
                } whitespace-nowrap  rounded-md transition-all duration-200 ease-in-out`
              }
              to={menuItem.route ?? ""}
            >
              <div className={`flex items-center ${isSideBarOpen ? "gap-2" : "gap-0"} px-4`}>
                <span className="text-xl">{menuItem.icon}</span>
                {isSideBarOpen && <span>{menuItem.title}</span>}
              </div>
            </NavLink>
          );
        })}
      </nav>

      {isSideBarOpen && (
        <div className="absolute bottom-0 mx-4 mb-4">
          <p>
            Version: <span className="text-gray-700">1.5</span>
          </p>
          <p>Last login:</p>
          <p className="text-gray-700">{lastLogin}</p>
        </div>
      )}
    </div>
  );
};

export default SideBar;
